import React, { useEffect, useState } from "react";
import {
  Typography,
  Stack,
  Breadcrumbs,
  Link,
  Box,
  Button,
} from "@mui/material";
import Read from "../../utils/read/Read";
import CssBaseline from "@mui/material/CssBaseline";
import KeyIcon from "@mui/icons-material/Key";

const ReadPasarelaPagoIntegraciones = () => {
  const [contador] = useState(0);
  useEffect(() => {}, [contador]);

  return (
    <React.Fragment>
      <CssBaseline />
      <Box sx={{ width: "100%" }} paddingTop={5} paddingBottom={5}>
        <Stack spacing={5}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Inicio
            </Link>
            <Typography color="text.primary">
              Integraciones Pasarela de Pago
            </Typography>
          </Breadcrumbs>
          <Button
            variant="contained"
            tabIndex={-1}
            startIcon={<KeyIcon />}
            href={`/pasarela-pago-integraciones/create`}
            sx={{ width: { xs: "100%", md: "100%", lg: "35%" } }}
          >
            Generar credenciales de integracion
          </Button>
          <Read
            config={{
              admin: true,
              title: "Integraciones registradas",
              endpoint: "/pasarela-pago-integraciones",
              id: "Username",
              onDelete: "/pasarela-pago-integraciones",
              headers: [
                {
                  id: "label",
                  numeric: false,
                  disablePadding: true,
                  label: "Integracion",
                },
                {
                  id: "email",
                  numeric: false,
                  disablePadding: true,
                  label: "Usuario (email)",
                },
                {
                  id: "status",
                  numeric: false,
                  disablePadding: true,
                  label: "Estado",
                },
                {
                  id: "UserCreateDate",
                  numeric: false,
                  disablePadding: true,
                  label: "Creado",
                },
              ],
            }}
          />
        </Stack>
      </Box>
    </React.Fragment>
  );
};

export default ReadPasarelaPagoIntegraciones;
